import { ModuleWithProviders, NgModule } from '@angular/core';
import { AbModule } from '@df/module-ab/ab.module';
import './ab-cms2-config';
import { providers } from './ab-cms2.providers';
import { AbCms2ShortcutsProvider } from './shortcuts/ab-cms2-shortcuts.provider';

@NgModule({
    imports: [AbModule]
})
export class AbCms2Module {
    static forRoot(
        options: { componentHideOption: boolean; binding: boolean } = { componentHideOption: true, binding: true }
    ): ModuleWithProviders<AbCms2Module> {
        return {
            ngModule: AbCms2Module,
            providers: providers(options)
        };
    }

    constructor(abCms2ShortcutsProvider: AbCms2ShortcutsProvider) {
        abCms2ShortcutsProvider.appInitialize();
    }
}
